import { Injectable } from '@angular/core';

import { AgentServiceBase } from './agent-service-base';

@Injectable({
    providedIn: 'root'
})
export class AiGeneralAgentService extends AgentServiceBase {

    protected override get agentName(): string {
        return 'general';
    }
}
